var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('vue-simplemde',{ref:"markdownEditor",attrs:{"configs":_vm.configs},on:{"blur":function($event){return _vm.saveText()}},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }